export enum CampaignType {
  TOMRA = 'tomra',
  TOKEN = 'token',
  CASHBACK_BRANDS = 'cashback-brands',
}
